if (!Element.prototype.matches) {
	Element.prototype.matches = Element.prototype.msMatchesSelector ||
		Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
	Element.prototype.closest = function(s) {
		var el = this;

		do {
			if (el.matches(s)) return el;
			el = el.parentElement || el.parentNode;
		} while (el !== null && el.nodeType === 1);
		return null;
	};
}

const churches = document.querySelectorAll('.church-row td:nth-child(2), .church-row td:nth-child(3), .church-row td:nth-child(4), .church-row td:nth-child(5)');
if ( churches && churches.length > 0 ) {
	for( let church of churches ) {
		church.addEventListener('click', async evt => {
			try {
				let church_id = church.closest('tr').dataset.churchId;
				const result = await axios.get(`/api/pastors-from-church/${church_id}`, {
					headers: {
						userid: currentUserId
					}
				});

				if ( result.data.length > 0 ) {
					const tg = document.querySelector( '#modalPastors' );
					const tbody = tg.querySelector('tbody');
					tbody.innerHTML = '';
					tg.querySelector('tbody').innerHTML = makePastorTable(result.data);
					$(tg).modal( 'show' );
				}
				else {
					alert( '소속된 목회자가 없습니다.' );
				}

			} catch ( error ) {
				console.log( error.response ? error.response : ( error.request ? error.request : error ));
				alert( '오류 발생' );
			}

		});
	}
}

const homepages = document.querySelectorAll('.church-row td.homepage');
if ( homepages && homepages.length > 0 ) {
	for( let el of homepages ) {
		el.addEventListener('click', (evt) => {
			let url = evt.target.textContent;
			if ( url ) {
				if ( url.match(/^https?(\:)(\/\/)/i).length === 0 ) {
					url = 'http://' + url;
				}

				window.open(url);
			}
		});
	}
}
